module.exports = __webpack_public_path__ + "static/104-inspecting-bill-finance-document 1-529ad574104fa45a199d3a98c4cffbb3.svg";